import { AutoStoriesRounded } from "@mui/icons-material";

const ReportNav = ({ examName, totalCorrect, total }) => {
  return (
    <nav>
      <ul className="report-nav">
        <li>
          <div>
            <AutoStoriesRounded color="iconGray" />
          </div>
          <div>
            <h4 className="mb-0 ellipsis">{examName}</h4>
            <small className="mb-0">Evaluation Report</small>
          </div>
        </li>

        <li>
          <div className="side-by-side">
            <p className="mb-0 score">
              <b>{total > 0 ? Math.round((totalCorrect / total) * 100) : 0}%</b>
            </p>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default ReportNav;
